/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlayerSkipBack = createReactComponent("player-skip-back", "IconPlayerSkipBack", [
  ["path", { d: "M20 5v14l-12 -7z", key: "svg-0" }],
  ["path", { d: "M4 5l0 14", key: "svg-1" }]
]);

export { IconPlayerSkipBack as default };
//# sourceMappingURL=IconPlayerSkipBack.js.map
